import { type FC } from 'react';
import { Outlet } from 'react-router';
import Footer from '@Components/common/footer/Footer';
import { ImpersonationBanner } from '@Components/common/impersonation/ImpersonationBanner';

const Layout: FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100dvh - var(--core-header-height, 0px))',
        overflow: 'hidden',
      }}
    >
      <div style={{ flexShrink: 0 }}>
        <ImpersonationBanner />
      </div>
      <main
        style={{ flex: 1, overflowY: 'auto', paddingBottom: '80px', backgroundColor: '#f5f5f5' }}
      >
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
